import { useCallback, useEffect, useMemo, useState } from 'react'

export const EMPTY_MAP_PANEL_STATE = {
  group: null,
  page: 1,
  collapsed: false,
  showClusterList: false,
  scrollTop: 0
}

const getPanel = (entry, filtersKey) => {
  if (!entry) return EMPTY_MAP_PANEL_STATE
  if (entry.filtersKey === filtersKey) return entry.panel
  return { ...entry.panel, page: 1, scrollTop: 0 }
}

const useExchangeMapPanelState = (tabKey, filtersKey, validTabKeys) => {
  const [panels, setPanels] = useState(() => new Map())
  const entry = panels.get(tabKey)
  const panel = useMemo(() => getPanel(entry, filtersKey), [entry, filtersKey])

  const setPanel = useCallback(
    update => {
      setPanels(previous => {
        const saved = previous.get(tabKey)
        const current = getPanel(saved, filtersKey)
        const next = typeof update === 'function' ? update(current) : update
        if (next === current) return previous

        const result = new Map(previous)
        result.set(tabKey, { filtersKey, panel: next })
        return result
      })
    },
    [tabKey, filtersKey]
  )

  const validKeys = JSON.stringify(validTabKeys)
  useEffect(() => {
    const keys = new Set(JSON.parse(validKeys))
    setPanels(previous => {
      const result = new Map(previous)
      previous.forEach((saved, key) => {
        if (!keys.has(key)) result.delete(key)
      })
      const saved = result.get(tabKey)
      if (saved && saved.filtersKey !== filtersKey) {
        result.set(tabKey, { filtersKey, panel: getPanel(saved, filtersKey) })
        return result
      }
      return result.size !== previous.size ? result : previous
    })
  }, [tabKey, filtersKey, validKeys])

  return [panel, setPanel]
}

export default useExchangeMapPanelState
